import { Card, Col, Row } from 'reactstrap';
import { toLocaleFormatSlash } from '../../../helpers/dateFormat';

interface TerminatedEmployeeFormBasicInfoProps {
  terminationDate: string | Date;
  terminationCategory: string;
  terminationReason: string;
  terminationNotes: string;
  ptoBalance: number;
}

const TerminatedEmployeeFormBasicInfo = ({
  terminationDate,
  terminationCategory,
  terminationReason,
  terminationNotes,
  ptoBalance,
}: TerminatedEmployeeFormBasicInfoProps) => {
  return (
    <Card style={{ padding: '40px 60px', background: '#eaeaff' }}>
      <Row className="mb-2">
        <h3>Basic Info</h3>
      </Row>
      <Row
        className="d-flex mb-2 align-items-center justify-content-between"
        style={{ borderBottom: '2px solid #dddddd' }}
      >
        <h4 className="text-muted">Termination Date</h4>
        <h4>{toLocaleFormatSlash(terminationDate)}</h4>
      </Row>
      <Row
        className="d-flex mb-2 align-items-center justify-content-between"
        style={{ borderBottom: '2px solid #dddddd' }}
      >
        <h4 className="text-muted">Termination Type</h4>
        <h4>{terminationCategory}</h4>
      </Row>
      <Row className="d-flex mb-2 justify-content-between" style={{ borderBottom: '2px solid #dddddd' }}>
        <Col className="p-0 m-0" lg="4">
          <h4 className="text-muted">Termination Reason</h4>
        </Col>
        <Col className="p-0 m-0 a" lg="8">
          <h4 className="text-right" style={{ whiteSpace: 'pre-line' }}>
            {terminationReason}
          </h4>
        </Col>
      </Row>
      <Row className="d-flex mb-2 justify-content-between" style={{ borderBottom: '2px solid #dddddd' }}>
        <Col className="p-0 m-0" lg="4">
          <h4 className="text-muted">Notes</h4>
        </Col>
        <Col className="p-0 m-0 a" lg="8">
          <h4 className="text-right" style={{ whiteSpace: 'pre-line' }}>
            {terminationNotes}
          </h4>
        </Col>
      </Row>
      <Row className="mb-2 mt-4">
        <h3>PTO Balance</h3>
      </Row>
      <Row
        className="d-flex mb-2 align-items-center justify-content-between"
        style={{ borderBottom: '2px solid #dddddd' }}
      >
        <h4 className="text-muted">Available PTO Balance</h4>
        <h4>{ptoBalance != null && !isNaN(ptoBalance) ? `${ptoBalance} Hrs` : '0 Hrs'}</h4>
      </Row>
    </Card>
  );
};

export default TerminatedEmployeeFormBasicInfo;
